import { render, staticRenderFns } from "./ymShouye.vue?vue&type=template&id=120abc5d&scoped=true&"
import script from "./ymShouye.vue?vue&type=script&lang=js&"
export * from "./ymShouye.vue?vue&type=script&lang=js&"
import style0 from "./ymShouye.vue?vue&type=style&index=0&id=120abc5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120abc5d",
  null
  
)

export default component.exports